import React, { useState } from 'react';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { customCSS } from '../../../common/docs/content';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import ParentDocCard from '../../common/ParentDocCard';
import CustomCSSForm from './CustomCSSForm';
import showAlert from '../../../common/utils/alert';
import { CustomCssCDN } from './CustomCssCDN';
import DocsLink from '../../../common/custom/DocsLink';

export const CustomCss = ({
  projectId,
  version,
  projectDetail,
  showCustomCSSLoader,
  showCustomCSSClassLoader,
  actions,
  showCustomCSSUrlLoader,
  appSetting,
  toggleCssFullscreen,
  togglestate,
  deleteFlag,
}) => {
  const { content } = projectDetail;
  const [isNewCustomCSSClass, setIsNewCustomCSSClass] = useState(false);
  const handleCustomCSSSubmit = (values) => {
    actions.addProjectCustomCss({
      projectId,
      version,
      data: values,
    });
  };

  const handleCustomCSSClassSubmit = (values, setErrors, setSubmitting, resetForm) => {
    setSubmitting(false);
    actions
      .addProjectCustomCssClass({
        projectId,
        version,
        data: values,
      })
      .then((_response) => {
        resetForm();
      });
  };

  const handleCustomCSSClassDelete = (uuid) => {
    const preConfirm = () => {
      actions.deleteProjectCustomCssClass({ projectId, version, uuid });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  return (
    <>
      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
        <div className="row mx-auto">
          <ParentCardNoCol
            title="Add Custom CSS"
            bgColor="drapcode-violet"
            icon="customCSS"
            CtaComponent={
              <button
                type="button"
                style={{ background: 'transparent', border: 'none' }}
                onClick={toggleCssFullscreen}
                title="Toggle Fullscreen"
              >
                <i
                  className={`btn btn-outline-primary btn-xs btn-icon-only ${drapcodeIcon(
                    'fullscreen',
                  )}`}
                  style={{ lineHeight: 1 }}
                ></i>
              </button>
            }
          >
            <CustomCSSForm
              content={content}
              handleCustomCSSSubmit={handleCustomCSSSubmit}
              showCustomCSSLoader={showCustomCSSLoader}
              togglestate={togglestate}
            />
          </ParentCardNoCol>
        </div>

        <CustomCssCDN
          projectId={projectId}
          version={version}
          projectDetail={projectDetail}
          actions={actions}
          showCustomCSSUrlLoader={showCustomCSSUrlLoader}
          appSetting={appSetting}
          deleteFlag={deleteFlag}
        />
      </div>
      <ParentDocCard>
        <h5>
          <b>About Custom CSS</b>
        </h5>
        <p>{customCSS}</p>
        <DocsLink link="https://academy.drapcode.com/docs/app-settings/custom-css#1-open-app-settings" />
      </ParentDocCard>
    </>
  );
};
